import React from "react";
import styled from "@emotion/styled";
import colors from '../../../sass/brand_palette.scss';
import withTranslator from "../Translator/withTranslation";


const TextContainer = styled.span`
    @media (max-width:768px){
        display:${ props => props.showNumber ? 'block' : 'none'};
        color: ${ props => props.showNumber ? '#fff' : 'inherit'};
    }
`;

const TooltipContainer = styled.div`
    position: absolute;
    border: 1px solid white;
    width: 300px;
    margin-left: calc(-150px + 0.25rem);
    top: 40px;
    z-index: 200;
    
    &:before{
        content: ' ';
        width: 0;
        height: 0;
        border-right: 10px solid transparent;
        border-bottom: 10px solid ${colors.blue1};
        border-left: 10px solid transparent;
        top: -10px;
        left: 145px;
        position: absolute;
    }
`;

const TooltipInner = styled.div`
    padding: .5em 1em;
    text-transform: capitalize;
`;

class PhoneNumberComponent extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            open: false
        };
    }
    
    mouseEnter = () => {
        if (this.props.tooltipEnabled) {
            this.setState(state => ({ open: true }))
        }
    };
    
    mouseLeave = () => {
        if (this.props.tooltipEnabled) {
            this.setState(state => ({ open: false }));
        }
    };
    
    render() {
        const { open } = this.state,
            src = '/assets/img/front/icons/phone-circle-'+this.props.iconColor+'.svg';
        const { t } = this.props;
        const tellink = "tel:"+t('phone_availability').replace(/ /gi, '');
        const disabled = true;
        return (
            <div className={this.props.showNumber ? 'mb-1' : 'relative'}>
                <a href={tellink} className="flex font-w600 font-120 blue1" onMouseEnter={this.mouseEnter} onMouseLeave={this.mouseLeave}>
                    <img alt="phone" className="mr-2" src={(this.props.searchURLBase ? this.props.searchURLBase : '') + src} height={this.props.height} width={this.props.width}/>
                    <TextContainer showNumber={this.props.showNumber}>{t('phone_availability')}</TextContainer>
                </a>
                {open && !disabled ?
                    <TooltipContainer className="border-radius-default text-center">
                        <TooltipInner className="bg-blue1 white font-150">{t('phone_availability')}</TooltipInner>
                        <TooltipInner className="text-center bg-white blue1">{t('monday_short')+' - '+t('friday_short')+': '+ t('availability_days_weekday')}</TooltipInner>
                        <TooltipInner className="text-center bg-white blue1 hide">{t('saturday_short') + ': '+ t('availability_days_weekend')}</TooltipInner>
                    </TooltipContainer> : ''}
            </div>
        );
    }
}

export const PhoneNumber = withTranslator(PhoneNumberComponent);